import { createPlugin, createRouteRef, createRoutableExtension } from '@backstage/core-plugin-api';

export const storybookRouteRef = createRouteRef({
  id: 'storybook',
});

export const storybookPlugin = createPlugin({
  id: 'storybook',
  routes: {
    root: storybookRouteRef,
  },
});

export const StorybookPage = storybookPlugin.provide(
  createRoutableExtension({
    component: () =>
      import('./components/StorybookComponent').then((m) => m.StorybookComponent),
    mountPoint: storybookRouteRef,
  }),
);
